// React Scroll
import { Element } from 'react-scroll';

// Domain
import { getFieldId, getFieldType, getFieldsetScrollName } from '../../../domain/form/formUseCase';

// Components
import MarkdownContainer from '../MarkdownContainer/MarkdownContainer';

// Styles
import styles from './FormFieldset.module.css';

/**
 * Fieldset component for grouping related fields
 * @param {object} props - Component props
 * @param {FormFieldset} props.fieldset - Fieldset configuration
 * @param {(field: FormItem) => JSX.Element} props.children - Children function
 * @param {string} [props.containerId] - Scroll container id for namespaced scroll target
 * @param {(field: FormItem) => boolean} [props.isFieldVisible] - Domain-driven visibility (hideConditions)
 * @returns {JSX.Element} Fieldset component
 */
function FormFieldset({
  fieldset,
  children,
  containerId,
  isFieldVisible = () => true,
}) {
  const legendId = `fieldset-legend-${fieldset.id}`;
  return (
    <Element name={getFieldsetScrollName(containerId, fieldset.id)} className="scroll-element">
      <fieldset className={styles['form-fieldset']} aria-labelledby={legendId}>
        <div id={legendId} className={styles['form-legend']}>
          <MarkdownContainer content={fieldset.legend} />
        </div>
        {fieldset.subLegend && (
          <MarkdownContainer content={fieldset.subLegend} className={styles['form-sublegend']} />
        )}

        <div className={styles['form-fieldset-content']}>
          {fieldset.fields.map((field) => {
            const fieldId = getFieldId(field);
            if (!fieldId) return null;
            if (!isFieldVisible(field)) return null;
            const fieldKey = getFieldType(field) === 'radio'
              ? `${fieldId}-${field.radio?.value ?? ''}`
              : fieldId;
            return (
              <div key={fieldKey}>
                {children(field)}
              </div>
            );
          })}
        </div>
      </fieldset>
    </Element>
  );
}

export default FormFieldset;
